var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9998 14.3952H4.3998C3.5158 14.3952 2.7998 13.6792 2.7998 12.7952V4.7952C2.7998 3.9112 3.5158 3.1952 4.3998 3.1952H15.5998C16.4838 3.1952 17.1998 3.9112 17.1998 4.7952V12.7952C17.1998 13.6792 16.4838 14.3952 15.5998 14.3952H10.6998L7.3318 17.3912C6.8158 17.8504 5.9998 17.484 5.9998 16.7936V14.3952Z",
    stroke: "#B3BAD1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.792H14",
    stroke: "#B3BAD1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.392H11.6",
    stroke: "#B3BAD1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageGrey);
export default __webpack_public_path__ + "static/media/messageGrey.923bc0ccaa59ddb7ed6c1ac31168a6d1.svg";
export { ForwardRef as ReactComponent };